<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

				<label v-if="viewableBySalesman" class="mgr_15">
					<input type="checkbox" v-model="by_salesman" />
					<em class="lt_text"> By Salesman</em>
				</label>

				<span class="mgr_10">
					<CountrySelect v-model.trim="country" :bool="true" @us_code="code => (us_code = code)" />
					<label class="int_type_no_border mgr_10" style="vertical-align: baseline;"><input type="checkbox" v-model="non_us_yn" @change="changeNonUsYn()" true-value="Y" false-value="N" /> NON-US</label>
				</span>

				<StateSelect v-model.trim="state" :country="country" class="mgr_15" />

				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 3%;" />
						<col style="width: 5.5%;" />
						<col />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col style="width: 5.5%;" />
						<col v-if="is_admin" style="width: 5.5%;" />
						<col v-if="is_admin" style="width: 5.5%;" />
						<col v-if="is_admin" style="width: 5.5%;" />
					</colgroup>
					<thead>
						<tr>
							<th>No</th>
							<th>Sales Id</th>
							<th>Sales Man</th>
							<th>Margin</th>
							<th>Sales Amt</th>
							<th>Return Amt</th>
							<th>Net Sales Amt</th>
							<th>Receipt Amt</th>
							<!-- <th>Post Amt</th> -->
							<th>AR Balance</th>
							<th>Packing</th>
							<th>Packed</th>
							<th>Est Amt</th>
							<th>Shipping Charge</th>
							<th>Shipping Charge Discount</th>
							<th>Net Sales Except For Shipping</th>
							<th v-if="is_admin">Sales Cost</th>
							<th v-if="is_admin">Return Cost</th>
							<th v-if="is_admin">Net Cost</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in root.list" v-bind:key="index">
							<td>{{ index + 1 }}</td>
							<td>{{ item.sales_group_code }}</td>
							<td>{{ item.display_name }}</td>
							<td class="al_right">{{ item.margin | toCurrency }} %</td>
							<td class="al_right">
								<a href="javascript: void(0);" @click="gotoInvoice(item, 'S')">{{ item.sales_amount | toCurrency }}</a>
							</td>
							<td class="al_right">
								<a href="javascript: void(0);" @click="gotoInvoice(item, 'R')">{{ item.return_amount | toCurrency }}</a>
							</td>
							<td class="al_right">{{ item.net_sales_amount | toCurrency }}</td>
							<td class="al_right">{{ item.receipt_amount | toCurrency }}</td>
							<!-- <td class="al_right">{{ item.post_amount | toCurrency }}</td> -->
							<td class="al_right">{{ item.balance_amount | toCurrency }}</td>
							<td class="al_right">{{ item.packing_amount | toCurrency }}</td>
							<td class="al_right">{{ item.packed_amount | toCurrency }}</td>
							<td class="al_right">{{ item.est_amount | toCurrency }}</td>
							<td class="al_right">{{ item.shipping_charge | toCurrency }}</td>
							<td class="al_right">{{ item.shipping_charge_discount_amount | toCurrency }}</td>
							<td class="al_right">{{ (item.net_sales_amount - (item.shipping_charge - item.shipping_charge_discount_amount)) | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ item.total_cost | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ item.return_cost | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ item.net_cost | toCurrency }}</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>TOTAL</td>
							<td class="al_right">{{ root.margin | toCurrency }} %</td>
							<td class="al_right">{{ root.sales_amount | toCurrency }}</td>
							<td class="al_right">{{ root.return_amount | toCurrency }}</td>
							<td class="al_right">{{ root.net_sales_amount | toCurrency }}</td>
							<td class="al_right">{{ root.receipt_amount | toCurrency }}</td>
							<!-- <td class="al_right">{{ root.post_amount | toCurrency }}</td> -->
							<td class="al_right">{{ root.balance_amount | toCurrency }}</td>
							<td class="al_right">{{ root.packing_amount | toCurrency }}</td>
							<td class="al_right">{{ root.packed_amount | toCurrency }}</td>
							<td class="al_right">{{ root.est_amount | toCurrency }}</td>
							<td class="al_right">{{ root.shipping_charge | toCurrency }}</td>
							<td class="al_right">{{ root.shipping_charge_discount_amount | toCurrency }}</td>
							<td class="al_right">{{ (root.net_sales_amount - (root.shipping_charge - root.shipping_charge_discount_amount)) | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ root.total_cost | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ root.return_cost | toCurrency }}</td>
							<td v-if="is_admin" class="al_right">{{ root.net_cost | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiIndex, apiSalesReturnReceipt } from '@/api/report/report';
import { reportRenderHorizontally, objectToFormData, objectToUrlParam, reportMrtUrl } from '@/api/util';
import CodeSelect from '@/components/common/CodeSelect';
import CountrySelect from '@/components/common/CountrySelect';
import StateSelect from '@/components/common/StateSelect';
import { today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker';

export default {
	data: function() {
		return {
			root: '',
			from_date: today(),
			to_date: today(),
			by_salesman: false,
			salesGroups: [],
			sales_group_code: '',
			state: '',
			states: [],
			countries: [],
			country: '',
			non_us_yn: 'N',

			us_code: '',
		};
	},
	components: {
		CustomDatePicker,
		CodeSelect,
		CountrySelect,
		StateSelect,
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		viewableBySalesman() {
			return this.company_id === 'beautyplus' || this.company_id === 'hairplus';
		},
		is_admin() {
			return this.user && this.user.admin_yn === 'Y';
		},
		isCountryOrStateSelected: {
			get() {
				return !!this.country || !!this.state;
			},
		},
	},
	watch: {
		isCountryOrStateSelected: {
			handler() {
				if (this.non_us_yn === 'Y' && this.isCountryOrStateSelected) this.non_us_yn = 'N';
			},
		},
	},
	methods: {
		gotoInvoice(item, type) {
			let routeData = this.$router.resolve({
				name: 'invoiceMain',
				query: { invoice_type: type, invoice_date_from: this.from_date, invoice_date_to: this.to_date, sales_group_code: item.sales_group_code, country: this.country || 'NON_SELECT', state: this.state },
			});
			window.open(routeData.href, 'invoiceMain');
		},
		changeNonUsYn() {
			if (this.non_us_yn === 'Y') {
				this.country = '';
				this.state = '';
			}
		},
		async selectData() {
			const paramObj = {
				from_date: this.from_date || '',
				to_date: this.to_date || '',
				by_salesman: this.by_salesman || false,
				sales_group_code: this.sales_group_code || '',
				country: (this.non_us_yn === 'Y' ? this.us_code : this.country) || '',
				state: this.state || '',
				non_us_yn: this.non_us_yn || 'N',
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiSalesReturnReceipt(param);
			if (data.value && Array.isArray(data.value.list)) {
				data.value.list.forEach(el => (el.display_name = this.by_salesman ? el.salesman_name : el.sales_group_name));
			}

			this.root = data.value;
		},
		async reportPrint() {
			this.root.type = 'print';
			this.root.is_admin = this.is_admin;
			// console.log(JSON.stringify(this.root, null, 4));
			reportRenderHorizontally(this.root, 'SalesReturnReceipt', reportMrtUrl('SalesReturnReceipt'));
		},
		async index() {
			const param = { salesGroup: true };
			const { data } = await apiIndex(objectToUrlParam(param));
			this.salesGroups = data.salesGroupList;
		},
	},
	mounted() {
		// console.log(this.user.margin_viewable);
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesReturnReceipt');
		this.$store.commit('setSubTitle', 'Report -> Sales/Return/ReceiptReport');
		this.index();
	},
};
</script>

<style scoped></style>
